import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import ConfirmationNumberOutlinedIcon from "@mui/icons-material/ConfirmationNumberOutlined";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import QueryStatsOutlinedIcon from "@mui/icons-material/QueryStatsOutlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export function getPlatformHomePath(role) {
  if (role === "Super") return "/Super";
  if (role === "Partner") return "/Partner/events";
  if (role === "Usher") return "/Usher";
  if (role === "Admin") return "/Admin";
  return "/";
}
const EVENT_ID_RE =
  /^\/event\/(?:dashboard|live|tickets|requests|orders\/requests|invitations|edit)\/([^/]+)/;

export function getEventIdFromPath(pathname) {
  const m = pathname.match(EVENT_ID_RE);
  return m?.[1] || null;
}

/** Paths that must match exactly — avoid /Super lighting up on /Super/Partner/... */
const EXACT_MATCH_PATHS = new Set([
  "/Super",
  "/Admin",
  "/Usher",
  "/events",
  "/Partner/events",
]);

export function isNavItemActive(pathname, itemPath) {
  if (!pathname || !itemPath) return false;
  if (pathname === itemPath) return true;
  if (EXACT_MATCH_PATHS.has(itemPath)) return false;
  return pathname.startsWith(`${itemPath}/`);
}

export function getPlatformNav(role, pathname, user) {
  const eventId = getEventIdFromPath(pathname);

  if (eventId && ["Partner", "Super", "Admin"].includes(role)) {
    const homePath = getPlatformHomePath(role);
    const homeLabel =
      role === "Partner" ? "My events" : role === "Super" ? "Super overview" : "Admin overview";
    const items = [
      { path: `/event/dashboard/${eventId}`, label: "Dashboard", icon: DashboardOutlinedIcon },
      { path: `/event/live/${eventId}`, label: "Live check-in", icon: QueryStatsOutlinedIcon },
      { path: `/event/tickets/${eventId}`, label: "Tickets", icon: ConfirmationNumberOutlinedIcon },
      { path: `/event/invitations/${eventId}`, label: "Guest lists", icon: MailOutlineIcon },
      { path: `/event/requests/${eventId}`, label: "Requests", icon: InboxOutlinedIcon },
    ];
    return {
      moduleLabel: "Event workspace",
      moduleColor: "#46109B",
      parentNav: { path: homePath, label: homeLabel, icon: ArrowBackIcon },
      items,
    };
  }

  if (role === "Partner") {
    const partnerName = user?.companyName || user?.username || "Partner";
    return {
      moduleLabel: partnerName,
      moduleColor: "#00C896",
      items: [
        { path: "/Partner/events", label: "My events", icon: EventOutlinedIcon },
        { path: "/Partner/profile", label: "Settings", icon: SettingsOutlinedIcon },
      ],
    };
  }

  if (role === "Super" || role === "Admin") {
    const home = role === "Super" ? "/Super" : "/Admin";
    const items = [
      { path: home, label: "Overview", icon: DashboardOutlinedIcon },
      { path: "/events", label: "All events", icon: EventOutlinedIcon },
    ];
    if (role === "Super") {
      items.push({ path: "/Super/Partner/search", label: "Partners", icon: StorefrontOutlinedIcon });
    }
    items.push(
      { path: "/Admins/TicketRequests", label: "Ticket requests", icon: InboxOutlinedIcon },
      { path: "/events/create", label: "Create event", icon: AddCircleOutlineIcon },
      { path: "/Admin/whatsappCampaigns", label: "Messaging", icon: CampaignOutlinedIcon },
      { path: "/Admin/whatsappConversations", label: "WhatsApp chats", icon: ForumOutlinedIcon }
    );
    return {
      moduleLabel: "Admin Panel",
      moduleColor: "#46109B",
      items,
    };
  }

  if (role === "Usher") {
    return {
      moduleLabel: "QR Scanner",
      moduleColor: "#6B2DC5",
      items: [
        { path: "/Usher", label: "Live scanner", icon: QrCodeScannerIcon },
      ],
    };
  }

  return null;
}

export function shouldUsePlatformShell(pathname, role) {
  if (!role || role === "User") return false;
  return getPlatformNav(role, pathname) != null;
}
